$(document).ready(function() {
  $('br').attr('aria-hidden','true');
  $('hr').attr('aria-hidden','true');
  // Product card 2nd Image
  $('.hidden .box-ratio img').attr('aria-hidden', 'true');
  $('a.dropdown__menulink.js-menu-link').removeAttr('aria-expanded');
});


// Social and External link warning Fixed
$(document).ready(function() {
  // Get current hostname (normalized: no 'www.' or protocol)
  const currentHost = window.location.hostname.replace('www.', '');

  // Select all HTTP/HTTPS links (excluding internal links, mailto, tel, and anchors)
  $('a[href^="http://"], a[href^="https://"]').each(function() {
    const $link = $(this);
    const linkHost = this.hostname.replace('www.', '');

    // Skip if link is internal or has no valid host (e.g., #anchor links)
    if (linkHost === currentHost || !linkHost) return;

    // Get link text (trimmed) or fallback to "this link"
    const linkText = $link.text().trim() || 'this link';
    const currentAriaLabel = $link.attr('aria-label');

    // Set aria-label (preserve existing or use link text + warning)
    $link.attr({
      'aria-label': currentAriaLabel 
        ? `${currentAriaLabel} (this link will open in new tab)` 
        : `${linkText} (this link will open in new tab)`,
      'target': '_blank',
      'rel': 'noopener noreferrer'
    });
    $link.attr({
      'title': currentAriaLabel 
        ? `${currentAriaLabel} (this link will open in new tab)` 
        : `${linkText} (this link will open in new tab)`,
      'target': '_blank',
      'rel': 'noopener noreferrer nofollow',
    });

    // Optional: Add visual indicator (e.g., ↗)
    $link.addClass('external-link');
  });
});


// Email Label to all Email Address
$(document).ready(function() {
  // Target ALL email links (any format)
  $('a[href^="mailto:"]').each(function() {
    // Extract email from href
    let email = $(this).attr('href').replace('mailto:', '').trim();
    
    // Clean email (remove query parameters, URL-encoded spaces, etc.)
    email = decodeURIComponent(email) // Handle %20, %40, etc.
            .split('?')[0]           // Remove ?subject=...
            .split('&')[0];           // Remove &body=...
    
    // Set aria-label
    $(this).attr('aria-label', 'Email Address: ' + email);
  });
});


// Phone Label to all Phone Number
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const $link = $(this);
    const visibleText = $link.text().trim(); // Get what's visually shown
    const existingLabel = $link.attr('aria-label') || '';

    // Only add if not already present
    if (!existingLabel.includes('Phone Number')) {
      const newLabel = `Phone Number: ${visibleText}` + (existingLabel ? `, ${existingLabel}` : '');
      $link.attr('aria-label', newLabel);
    }
  }); 
});


//Convert 3rd Party Heading into sequence
$(document).ready(function() {
  setTimeout(function() {
    $('.ls-box-title').each(function() {
      const content = $(this).html();
      const styledH2 = $('<h2>', {
        html: content,
        class: 'ls-box-title',
        style: 'font-family: Lato, sans-serif; font-style: normal; font-weight: 300; color: rgb(30, 23, 23); font-size: 22px; line-height: normal;'
      });
      $(this).replaceWith(styledH2);
    });
    // Remove Empty Heading
    $('h1, h2, h3, h4, h5, h6').each(function () {
        if ($(this).text().trim() === '') {
            $(this).remove();
        }
    });
  }, 4000); // 3-second delay
});

//Search Drawer Focus
$(document).ready(function () {
      // Cache the buttons
      const $searchButton = $('.slideout__trigger-search');
      const $closeButton = $('.slideout__trigger-drawer-sidebar');

      // When search button is clicked, wait briefly and focus the close button
      $searchButton.on('click', function () {
        // Give time for drawer to open (adjust timeout if needed)
        setTimeout(function () {
          $closeButton.focus();
        }, 300); // 300ms delay is usually enough
      });

      // When close button is clicked, return focus to the search button
      $closeButton.on('click', function () {
        // Allow drawer to close before focusing back
        setTimeout(function () {
          $searchButton.focus();
        }, 300);
      });
});


  //Quick view Button Focus
$(document).ready(function () {
    let $lastQuickViewButton = null;

    // When any Quick View button is clicked
    $('.js-quickview-trigger').on('click', function () {
      $lastQuickViewButton = $(this); // Save the clicked button
      // Wait for modal/dialog to be inserted and rendered
      setTimeout(function () {
        $('.slideout__trigger-quickview').focus();
      }, 1300); // Adjust delay if needed
    });

    // When the close button inside quick view is clicked
    $(document).on('click', '.slideout__trigger-quickview', function () {
      // Wait until dialog is closed (if animated)
      setTimeout(function () {
        if ($lastQuickViewButton) {
          $lastQuickViewButton.focus();
        }
      }, 1300);
    });

    // When Escape key is pressed and quick view dialog is open
    $(document).on('keydown', function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        // Wait until dialog is closed before returning focus
        setTimeout(function () {
          if ($lastQuickViewButton && $('.slideout__trigger-quickview').is(':visible') === false) {
            $lastQuickViewButton.focus();
          }
        }, 1300);
      }
    });
});


/// Product page size tab
$(document).ready(function () {
  // Set initial state on page load
  var checkedInput = $('input[name="size"]:checked');
  if (checkedInput.length) {
    var selectedLabel = $('label[for="' + checkedInput.attr('id') + '"]');
    selectedLabel.attr('aria-checked', 'true');
    $('#selected-option-1').text(checkedInput.val());
  }

  // Handle state change when user selects a different option
  $('input[name="size"]').on('change', function () {
    $('.swatches__form--label[role="radio"]').attr('aria-checked', 'false');

    var selectedLabel = $('label[for="' + this.id + '"]');
    if (selectedLabel.length) {
      selectedLabel.attr('aria-checked', 'true');
      $('#selected-option-1').text(this.value);
    }
  });
});

/// quick view Pop UP Size tab
(function waitForSwatches() {
  const $inputs = $('.swatches__form--input[type="radio"]');

  if ($inputs.length === 0) {
    // Wait for swatches to be rendered
    setTimeout(waitForSwatches, 100);
    return;
  }

  function updateAriaChecked(groupName) {
    $('input[name="' + groupName + '"]').each(function () {
      const id = $(this).attr('id');
      $('label[for="' + id + '"]').attr('aria-checked', 'false');
    });

    const $checked = $('input[name="' + groupName + '"]:checked');
    if ($checked.length) {
      const checkedId = $checked.attr('id');
      $('label[for="' + checkedId + '"]').attr('aria-checked', 'true');
    }
  }

  function updateAllGroups() {
    const groups = new Set();
    $('.swatches__form--input[type="radio"]').each(function () {
      groups.add($(this).attr('name'));
    });

    groups.forEach(function (groupName) {
      updateAriaChecked(groupName);
    });
  }

  updateAllGroups();

  $(document).on('change', '.swatches__form--input[type="radio"]', function () {
    updateAriaChecked($(this).attr('name'));
  });
})();


// product page Contact Button Dialog
$(document).ready(function () {
  var $contactTrigger = $('.js-contact-trigger');
  var $dialogCloseButtons = $('.js-modal-close');
  var $firstDialogClose = $dialogCloseButtons.first();

  // When the contact trigger button is clicked
  $contactTrigger.on('click', function () {
    // Wait for the dialog to appear (adjust timeout if needed)
    setTimeout(function () {
      $firstDialogClose.focus();
    }, 100); // You can increase this if there's a delay in opening the modal
  });

  // When any close button is clicked
  $dialogCloseButtons.on('click', function () {
    setTimeout(function () {
      $contactTrigger.focus();
    }, 100);
  });
});


//menu
$(document).ready(function () {
  const $menuItem = $('li#first-drop-down a.navigation__menulink.js-menu-link.js-open-dropdown-on-key.is_upcase-true');
  const $megaMenu = $('.megamenu.grid__wrapper');

  // Remove href to prevent navigation
  $menuItem.removeAttr('href');
  $menuItem.attr('role', 'button');
  $menuItem.attr('tabindex', '0');

  // Set initial aria-expanded state
  $menuItem.attr('aria-expanded', 'false');

  // Toggle the is-active class and aria-expanded on click
  $menuItem.on('click', function (e) {
    e.preventDefault();

    const isActive = $megaMenu.hasClass('is-active');

    $megaMenu.toggleClass('is-active');
    $menuItem.attr('aria-expanded', !isActive);
  });

  // Toggle the menu on Enter key
    $menuItem.on('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();

        const isActive = $megaMenu.hasClass('is-active');

        $megaMenu.toggleClass('is-active');
        $menuItem.attr('aria-expanded', !isActive);
      }
    });

  // Close the menu on Escape key and return focus
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      if ($megaMenu.hasClass('is-active')) {
        $megaMenu.removeClass('is-active');
        $menuItem.attr('aria-expanded', 'false').focus();
      }
    }
  });

  // Close the menu when focus is moved outside of the menu and the trigger
  $(document).on('focusin', function (e) {
    if (
      !$menuItem.is(e.target) &&
      $menuItem.has(e.target).length === 0 &&
      !$megaMenu.is(e.target) &&
      $megaMenu.has(e.target).length === 0
    ) {
      if ($megaMenu.hasClass('is-active')) {
        $megaMenu.removeClass('is-active');
        $menuItem.attr('aria-expanded', 'false');
      }
    }
  });
});

//menu 2nd
$(document).ready(function () {
  // For each dropdown trigger
  $('li#second-drop-down a.navigation__menulink.js-menu-link.js-aria-expand.js-open-dropdown-on-key.is_upcase-true').each(function () {
    const $menuItem = $(this);
    const $dropdown = $menuItem.closest('li').find('.js-dropdown-nested').first();

    // Remove href and set ARIA attributes
    $menuItem.removeAttr('href');
    $menuItem.attr({
      'role': 'button',
      'aria-expanded': 'false',
      'tabindex': '0'
    });

    // Toggle dropdown visibility on click
    $menuItem.on('click', function (e) {
      e.preventDefault();

      const isActive = $dropdown.hasClass('is-selected');

      // Close all other dropdowns
      $('.js-dropdown-nested').not($dropdown).removeClass('is-selected');
      $('li#second-drop-down a.navigation__menulink.js-menu-link.js-aria-expand.js-open-dropdown-on-key.is_upcase-true').not($menuItem).attr('aria-expanded', 'false');

      // Toggle current dropdown
      $dropdown.toggleClass('is-selected');
      $menuItem.attr('aria-expanded', !isActive);
    });

    // Toggle dropdown on Enter key
    $menuItem.on('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();

        const isActive = $dropdown.hasClass('is-selected');

        // Close all other dropdowns
        $('.js-dropdown-nested').not($dropdown).removeClass('is-selected');
        $('li#second-drop-down a.navigation__menulink.js-menu-link.js-aria-expand.js-open-dropdown-on-key.is_upcase-true').not($menuItem).attr('aria-expanded', 'false');

        // Toggle current dropdown
        $dropdown.toggleClass('is-selected');
        $menuItem.attr('aria-expanded', !isActive);
      }
    });

    // Close dropdown on Escape key
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        if ($dropdown.hasClass('is-selected')) {
          $dropdown.removeClass('is-selected');
          $menuItem.attr('aria-expanded', 'false').focus();
        }
      }
    });

    // Close dropdown if focus moves outside
    $(document).on('focusin', function (e) {
      if (
        !$menuItem.is(e.target) &&
        $menuItem.has(e.target).length === 0 &&
        !$dropdown.is(e.target) &&
        $dropdown.has(e.target).length === 0
      ) {
        if ($dropdown.hasClass('is-selected')) {
          $dropdown.removeClass('is-selected');
          $menuItem.attr('aria-expanded', 'false');
        }
      }
    });
  });
});

//mobile menu
$(function() {
  // Store button references
  var $openBtn = $('#mobilecollapsed');
  var $closeBtn = $('#mobileexpanded');
  
  // Focus management
  $openBtn.on('click', function() {
    setTimeout(function() {
      $closeBtn.trigger('focus');
    }, 50);
  });
  
  $closeBtn.on('click', function() {
    setTimeout(function() {
      $openBtn.trigger('focus');
    }, 50);
  });
});



$(document).ready(function () {
  const $input = $('#sort-by');
  const $ul = $('.value-list.js-hz-filter-list.a-left');
  const $container = $('.collection--grid_container');

  // Add .handler when input is focused or clicked
  $input.on('focus click', function () {
    $ul.addClass('handler');
  });

  // Add .handler when any part of UL is focused (e.g., via Tab or SR)
  $ul.on('focusin', function () {
    $ul.addClass('handler');
  });

  // ESC key removes handler
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      $ul.removeClass('handler');
      $input.blur(); // optional
    }
  });

  // When focus moves into the container (e.g., product grid), remove handler
  $container.on('focusin', function () {
    $ul.removeClass('handler');
  });

  // Catch all other focusout cases globally — use setTimeout to allow accurate detection
  $(document).on('focusout', function () {
    setTimeout(() => {
      const $focused = $(document.activeElement);
      const isStillInsideFilter = 
        $focused.is($input) || 
        $focused.closest('.value-list.js-hz-filter-list.a-left').length;

      const isInContainer = $focused.closest('.collection--grid_container').length;

      // Only remove if focus moved outside both the filter and UL, or into the container
      if (!isStillInsideFilter && !isInContainer) {
        $ul.removeClass('handler');
      }
    }, 1);
  });
});